export default __webpack_public_path__ + "static/media/return.5a7ea1cf.svg";